import packageJson from '../../package.json'

export const environment = {
	appVersion: packageJson.version,
	appName: packageJson.name,
	production: true,
}
